<template>
  <b-overlay
    :show="loading"
    rounded="sm"
    class="form-custom"
  >
    <div
      class="form-custom__container aside-components"
      :style="`width: ${formComponentsWidth}px;`"
    >
      <form-components @componentAdd="handleComponentAdd" />
    </div>
    <div
      class="form-custom__container"
      :style="`width: calc(100% - ${formComponentsWidth+formParamsWidth}px);`"
    >
      <form-render
        ref="formRender"
        :option="option"
        @selectField="handleFieldSelect"
        @change="defaultValueChange"
      />
    </div>
    <div
      class="form-custom__container aside-params"
      :style="`width: ${formParamsWidth}px;`"
    >
      <form-params
        v-if="paramsChangeShow"
        ref="formParams"
        :field-option-form="currentFieldOption"
        :common-data="option"
        @change="fieldOptionChange"
      >
        <my-tooltip :tooltip="$t('_components.btns.view')">
          <b-button
            variant="primary"
            class="btn"
            size="sm"
            @click="handleView"
          >
            <feather-icon
              icon="EyeIcon"
              class="cursor-pointer"
              size="20"
            />
          </b-button>
        </my-tooltip>
        <!-- <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            variant="success"
            class="btn"
            size="sm"
            @click="handleSave"
          >
            <feather-icon
              icon="DownloadIcon"
              class="cursor-pointer"
              size="18"
            />
          </b-button>
        </my-tooltip> -->
      </form-params>
      <c-modal
        :title="option.formName || ' '"
        size="xl"
        :visible="dialogShow"
        body-class="form-custom-modal"
        :footer="false"
        @close="dialogShow=false"
        @modelConfirm="dialogShow=false"
      >
        <template slot="content">
          <my-form
            ref="overFormRef"
            :data="{}"
            :option="option"
            page-key="add"
            :footer-visible="false"
            width="auto"
          />
        </template>
      </c-modal>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BButton, BOverlay,
} from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import CModal from '@/components/crud/modal.vue';
import MyForm from '@/components/myForm/index.vue';
import FormComponents from './components/formComponents.vue'
import FormRender from './components/formRender.vue'
import FormParams from './components/formParams.vue'
import MyTooltip from '../myTooltip.vue';

export default {
  components: {
    FormComponents,
    FormRender,
    FormParams,
    BButton,
    MyTooltip,
    CModal,
    MyForm,
    BOverlay,
  },
  props: {
    formComponentsWidth: {
      type: Number,
      default: 270,
    },
    formParamsWidth: {
      type: Number,
      default: 380,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      option: {
        columns: [],
      },
      currentFieldOption: {},
      dialogShow: false,
      paramsChangeShow: false,
    }
  },
  watch: {
    data: {
      handler(e) {
        if (e) {
          if (e.columns) {
            this.option = e
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleComponentAdd(e) {
      this.$refs.formRender.componentAdd(e)
    },
    handleFieldSelect(e) {
      console.log(11);
      this.paramsChangeShow = false
      this.currentFieldOption = e
      setTimeout(() => {
        this.paramsChangeShow = true
      }, 10);
    },
    fieldOptionChange(e) {
      const option = deepClone(this.option) || {}
      for (let i = 0; i < option.columns.length; i += 1) {
        const item = option.columns[i];
        if (item.field === e.field) {
          option.columns[i] = e
        }
      }
      this.option = option
    },
    defaultValueChange(object) {
      const temp = deepClone(this.currentFieldOption)
      Object.keys(object).forEach(key => {
        const item = object[key]
        if (key === temp.field) {
          temp.formOption.value = item
        }
      })
      this.currentFieldOption = temp
    },
    handleView() {
      this.dialogShow = true
    },
    async handleSave() {
      const params = await this.$refs.formParams.validationForm()
      if (params) {
        return Object.assign(params, {
          columns: this.option.columns,
        })
      }
      return false
    },
  },
}

</script>

<style lang='scss' scoped>
    .form-custom{
        height: 100%;
        background: #FFF;
        display: flex;
        align-items: stretch;
        &__container{
            // padding: 10px;
        }
        .aside-components{
            border-right: 1px solid;
            padding: 10px;
        }
        .aside-params{
            border-left: 1px solid;
        }
        .aside-components, .aside-params{
            // background: red;
            border-color: #e4e7ed;
        }
    }
</style>

<style lang="scss">
.form-custom-modal{
    height: 80vh;
}
</style>
